import React, { useState } from "react";
import { withRouter, useParams } from "react-router-dom";
import { connect } from "react-redux";
import styles from "./ResetPassword.module.scss";
import WelcomePanel from "../components/WelcomePanel/WelcomePanel";
import FormElement from "components/FormElement/FormElement";
import InputAdornment from "components/InputAdornment/InputAdornment";
import Button from "components/Button/Button";
import logo from "assets/img/compliancy-group-logo.png";
import { submitUserResetPasswordAction } from "store/actions/Actions";
import PassowordValidation from "components/PasswordValidation/PasswordValidation";
import { showPassword } from "helpers/utils";

const ResetPassword = (props) => {
    let { hash } = useParams();
    const [stateErrors, setStateErrors] = useState({
        password: "",
        "confirm-password": "",
      });
    const [passwords, setPasswords] = useState({
        main: '',
        confirm: ''
    });
    const [togglePasswordIcon, setTogglePasswordIcon] = useState(false)
    const [togglePasswordIconConfirm, setTogglePasswordIconConfirm] = useState(false)

    /* eslint-disable-next-line */
    const passwordValidationRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");

    const handleForgot = (e) => {

        const passwordMain = document.getElementById('pass-reset').value;
        const passwordConfirm = document.getElementById('pass-reset-confirm').value;

        if (!passwordMain || !passwordValidationRegex.test(passwordMain)) {
            setStateErrors((s) => ({ ...s, password: 'The password is not valid!' }));
        } else if (passwordMain !== passwordConfirm) {
            setStateErrors((s) => ({ ...s, "confirm-password": `Passwords don't match` }));
        } else {
            props.submitUserResetPasswordAction({ password: passwordMain, hash });
        }
    }

    const handlePasswordChange = (event) => {
        setPasswords({
            main: event.target.value
        });
    }

    const togglePasswordVisibility = (e, id, isPwdVisible, toggleSetter) => {
        e.preventDefault();
        toggleSetter(isPwdVisible);
        showPassword(id, isPwdVisible)
    }

    return (
        <WelcomePanel type="reset">
            <div className={styles["login-panel-heading"]}>
                <img className={styles.logo} src={logo} alt="" />
            </div>
            <div className={styles["login-panel-content"]}>
                <p className={styles.welcome}>Enter your new password!</p>
                <FormElement
                    errorMessage={stateErrors.password}
                >
                    <InputAdornment iconStart="fal fa-lock-alt">
                        <input
                            onChange={handlePasswordChange}
                            type="password"
                            autoComplete="off"
                            placeholder="Enter new password"
                            name="pass"
                            className={styles.password}
                            id="pass-reset"
                        />
                        <span className={styles['show-password']}>
                            <button
                                className={styles['password-button']}
                                onClick={(e) => togglePasswordVisibility(e, 'pass-reset', !togglePasswordIcon, setTogglePasswordIcon)}>
                                <i 
                                    className={togglePasswordIcon ? 'hide' : 'fas fa-eye'}
                                    title="show password"></i>
                                <i 
                                    className={!togglePasswordIcon ? 'hide' : 'fas fa-eye-slash'}
                                    title="hide password"></i>
                            </button>
                        </span>
                    </InputAdornment>
                </FormElement>

                {!passwordValidationRegex.test(passwords.main) ?
                    <PassowordValidation password={passwords.main} />
                :
                    ""
                }

                <FormElement
                    errorMessage={stateErrors["confirm-password"]}
                >
                    <InputAdornment iconStart="fal fa-lock-alt">
                        <input
                            onChange={() => setStateErrors((s) => ({ ...s, "confirm-password": `` }))}
                            type="password"
                            autoComplete="off"
                            placeholder="Confirm new password"
                            name="pass"
                            className={styles.password}
                            id="pass-reset-confirm"
                        />
                        <span className={styles['show-password']}>
                            <button
                                className={styles['password-button']}
                                onClick={(e) => togglePasswordVisibility(e, 'pass-reset-confirm', !togglePasswordIconConfirm, setTogglePasswordIconConfirm)}>
                                <i 
                                    className={togglePasswordIconConfirm ? 'hide' : 'fas fa-eye'}
                                    title="show password"></i>
                                <i 
                                    className={!togglePasswordIconConfirm ? 'hide' : 'fas fa-eye-slash'}
                                    title="hide password"></i>
                            </button>
                        </span>
                    </InputAdornment>
                </FormElement>
            </div>
            <br/>
            <div className={styles["login-panel-footer"]}>
                <Button text={"CHANGE PASSWORD"} onClick={handleForgot} />
            </div>
        </WelcomePanel>
    )
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
    submitUserResetPasswordAction,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPassword));
